// extracted by mini-css-extract-plugin
module.exports = {"footer":"FullReportModalFooter_footer__1Df6A"};